import styled from 'styled-components'

export const SFContainer = styled.div`
  padding: 24px;
`

export const BatchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const BatchTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
`

export const BatchInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 16px;
`

export const BatchField = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
`

export const BatchLabel = styled.p`
  font-size: 16px;
  font-weight: bold;
  margin-right: 16px;
  min-width: 150px;
`

export const BatchValue = styled.p`
  font-size: 16px;
`
export const BatchItemContainer = styled.div`
  border: 1px solid gray;
  border-radius: 12px;
  padding: 24px;
  @media (max-width: 720px) {
    padding: 8px;
  }
`
export const BatchItemBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;

  div {
    border: 1px solid lightgray;
    padding: 8px;
  }
`
export const BatchItemBox2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  div {
    border: 1px solid lightgray;
    padding: 8px;
  }
`

export const Image = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 16px;
`
